import { HttpException } from '../http/exceptions';

export function describeError(error: unknown): string {
  const status = error instanceof HttpException ? error.status : 0;

  if (status !== 0) {
    return `(status ${status})`;
  }

  return `(status 0): ${error instanceof Error ? error.message : 'unknown cause'}`;
}
